import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import { Chart, Axis, Tooltip, Schema, Geom, Coord } from "bizcharts";
import DataSet from "@antv/data-set";
import { Box } from "@mui/system";

import DownloadButton from "../Common/DownloadButton";
import img from "../../Assets/boxplot.png";

const BoxPlotChart = (props) => {
  const data = [
    { x: "", low: 0, q1: 0, median: 0, q3: 2, high: 5, outliers: [33, 37] },
  ];
  const { readString } = usePapaParse();
  const [csvData, setCSVData] = useState(undefined);

  const { DataView } = DataSet;
  const dv = new DataView().source(data);

  dv.transform({
    type: "map",
    callback: (obj) => {
      obj.range = [obj.low, obj.q1, obj.median, obj.q3, obj.high];
      return obj;
    },
  });

  useEffect(() => {
    readString(props.csv, {
      complete: (results, file) => {
        setCSVData(results.data);
      },
      download: true,
      header: true,
      dynamicTyping: true,
      error: (error, file) => {
        console.log("Error while parsing:", error, file);
      },
    });
  }, []);

  return (
    <Box marginBottom="1rem">
      <Box display="flex" justifyContent="space-between">
        <p
          className="titleChart"
          style={{
            fontFamily: "Roboto Condensed, sans-serif",
            width: "100%",
          }}
        >
          {props.title}
        </p>
        <DownloadButton csv={csvData} imageAsset={img} fileName={props.title} />
      </Box>
      <Box
        display="flex"
        justifyContent={"space-between"}
        sx={{ marginTop: "15px" }}
      >
        <Box>
          <p
            style={{
              paddingLeft: "2.6rem",
              color: "#5D5B5B",
              fontFamily: "Roboto Condensed, sans-serif",
            }}
          >
            Median: <b style={{ marginRight: "2rem" }}>{data[0].median}</b>{" "}
            Upper fence: <b>{data[0].high}</b>
          </p>
        </Box>
        <Box>
          <p
            style={{
              color: "#5D5B5B",
              fontFamily: "Roboto Condensed, sans-serif",
            }}
          >
            Max: {data[[0]].outliers[1]}
          </p>
        </Box>
      </Box>

      <Chart
        padding={[0, 20, 0, 45]}
        height={100}
        data={dv.rows}
        autoFit
        scale={{
          range: {
            max: 39,
          },
          outliers: {
            min: 0,
            max: data[0].outliers[1],
          },
        }}
      >
        <Tooltip
          showTitle={false}
          showMarkers={false}
          itemTpl={
            '<li class="g2-tooltip-list-item" data-index={index} style="padding:10px;">' +
            '<span style="background-color:#FFBB00;padding-bottom:5px;" class="g2-tooltip-marker"></span>' +
            "{name}<br/>" +
            '<span style="color:#22294d">High: {high}</span><br/>' +
            '<span style="color:#22294d">Q3: {q3}</span><br/>' +
            '<span style="color:#22294d">Median: {median}</span><br/>' +
            '<span style="color:#22294d">Q1: {q1}</span><br/>' +
            '<span style="color:#22294d">Low: {low}</span><br/>' +
            '<span style="color:#22294d">Outlier 1: 36</span><br/>' +
            '<span style="color:#22294d">Outlier 2: 39</span><br/>' +
            "</li>"
          }
        />
        <Axis name="range" visible={false} />
        <Axis name="x" visible={true} />

        <Schema
          position={"x*range"}
          shape={"box"}
          style={{
            stroke: "#FFBB00",
            fill: "#FFBB00",
            fillOpacity: 0.3,
          }}
          label={false}
          tooltip={[
            "x*low*q1*median*q3*high",
            (x, low, q1, median, q3, high) => {
              return {
                name: x,
                low,
                q1,
                median,
                q3,
                high,
                outline1: data[0].outliers[0],
                outline2: data[0].outliers[1],
              };
            },
          ]}
        />
        <Geom
          type="point"
          position="x*outliers"
          shape="circle"
          color="#F83D43"
          size={3}
          active={false}
          tooltip={[
            "x*low*q1*median*q3*high",
            (x, low, q1, median, q3, high) => {
              return {
                name: x,
                low,
                q1,
                median,
                q3,
                high,
                outline1: data[0].outliers[0],
                outline2: data[0].outliers[1],
              };
            },
          ]}
        />
        <Axis name="outliers" visible={false} />

        <Coord transpose />
      </Chart>
    </Box>
  );
};

export default BoxPlotChart;
